import * as React from 'react';
import { Props } from 'react';
import { setTimeout, clearTimeout } from 'timers';

import '../RegistrationAuthorization/RegistrationAuthorization.scss';
import i18next from 'i18next';
import PhoneInput from 'react-phone-input-2';

interface AuthorizationViewProps extends Props<AuthorizationView> {
    channelId: string;
    phone: string;
    error: string;
    setPhone: (phone: string) => any;
    onAuthorization: () => any;
    reauthorization: string | null;
    lang: string;
}

interface AuthorizationViewState {
    isShowError: boolean;
    isShowReauthorizationWarning: boolean;
}

export class AuthorizationView extends React.Component<AuthorizationViewProps, AuthorizationViewState> {
    timer: NodeJS.Timer;

    state = {
        isShowError: false,
        isShowReauthorizationWarning: false
    };

    showError = () => {
        this.setState({
            isShowError: true,
        }, () => {
            if (this.timer) {
                clearTimeout(this.timer);
            }
            setTimeout(() => this.setState({
                isShowError: false
            }), 5000);
        });
    }

    showReauthorizationWarning = () => {
        this.setState({
            isShowReauthorizationWarning: true,
        }, () => {
            if (this.timer) {
                clearTimeout(this.timer);
            }
            setTimeout(() => this.setState({
                isShowReauthorizationWarning: false
            }), 20000);
        });
    }

    onValueChange = (e: any) => {
        const { setPhone } = this.props;
        setPhone(e.replace(/[^0-9]+/g, ''));
    }

    componentDidMount() {
        const {error, reauthorization} = this.props;
        if (error) {
            this.showError();
        }
        if (reauthorization === 'true' || reauthorization === 'dif_msngr') {
            this.showReauthorizationWarning();
        }
    }

    componentWillReceiveProps(next: AuthorizationViewProps) {
        if (next.error && (next.error !== this.props.error)) {
            this.showError();
        }
        if (next.reauthorization && (next.reauthorization !== this.props.reauthorization)) {
            this.showReauthorizationWarning();
        }
    }

    render() {
        const {phone, onAuthorization, error, channelId, lang} = this.props;
        const {isShowError} = this.state;
        const countries = ['ru', 'by', 'am', 'ge', 'az', 'ua', 'kz', 'uz', 'ao', 'gr', 'si', 'fr', 'it', 'hu', 'cz',
            'bh', 'sg', 'mk', 'at', 'pl', 'lt', 'mt', 'be', 'ro', 'kw', 'es', 'au',
            'jo', 'tr', 'ch', 'lv', 'ae', 'de', 'us', 'gb', 'il'];

        return (
            <div className={`authorization-container ${channelId}`}>
                <div className={`authorization ${channelId}`}>
                    <div className={`auth-tab ${channelId}`}>
                        <div className={`auth-title auth-title-${channelId}`}>
                            {i18next.t('authorization')}
                        </div>
                    </div>
                    <div className='auth-message'>
                        <div className={`auth-error ${isShowError ? 'show' : ''}`} dangerouslySetInnerHTML={{__html: error}} />
                    </div>
                    <div className='auth-body'>
                        <div className='auth-body-title'>
                            {i18next.t('input_your_number')}
                        </div>
                        <div className='auth-body-phone'>
                            <PhoneInput
                                onlyCountries={countries}
                                preferredCountries={['ru', 'by', 'am', 'ge', 'az', 'ua', 'kz', 'uz']}
                                preserveOrder={['onlyCountries', 'preferredCountries']}
                                defaultCountry={(lang === 'ru' || lang === 'en') ? 'ru' : (lang === 'az') ? 'az' : 'ge'}
                                value={'+' + phone}
                                disableAreaCodes={true}
                                autoFocus={true}
                                autoFormat={false}
                                onChange={this.onValueChange}
                                placeholder={i18next.t('phone_number')}
                                enableSearchField={true}
                                dropdownClass={'phone-code-flag'}
                                buttonClass={'phone-flag-dropdown'}
                                countryCodeEditable={false}
                            />
                        </div>
                    </div>
                    <div>
                        <div className='auth-button-container'>
                            <div className={`auth-button ${channelId} ${!phone || !phone.length ? 'auth-gray' : ''}`} onClick={() => phone && phone.length && onAuthorization()}>
                                {i18next.t('ok')}
                            </div>
                        </div>
                        <div
                            className='auth-body-oferta'
                            dangerouslySetInnerHTML={{
                                __html: i18next.t('oferta', { link: 'https://static.konsierge.com/docs/konsierge_lite/public-offer' }) }}
                        />
                    </div>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/Authorization/AuthorizationView.tsx